export const experienceData = [
  {
    company: "Meta",
    role: "Software Engineer",
    date: "July 2025 - Present",
    bullets: [
      "On the Modern Recommender Systems (MRS) AI Kernel Foundation Model (FM) Co-design Team"
    ],
    tech: ["AI", "Recommender Systems"],
    logo: "meta_logo.png"
  },
  {
    company: "Instawork",
    role: "Product Engineering and Operations Intern",
    date: "Jan 2025 - April 2025",
    bullets: [
      "Built a multi-step certificate approval agent using GPT-4 Vision, AWS S3, and Cursor; automated 80% of manual forklift certificate reviews through document type detection, cert field extraction, and structured validation",
      "Built ProFinder, a full-stack web app that matches workers to job postings by role and location; prototyped in 3 days with Replit AI Agent, improving marketplace liquidity and delivering a 10x productivity boost for the Product team"
    ],
    tech: ["GPT-4 Vision", "AWS S3", "Cursor", "Replit AI Agent", "Full-stack"],
    logo: "instawork_logo.png"
  },
  {
    company: "NVIDIA",
    role: "Product Management & Software Engineering Contractor",
    date: "Aug 2024 - Dec 2024",
    bullets: [
      "Working on the DGX Cloud Resource Governance team to improve the Navigator GPU allocation platform by leveraging Retool, JavaScript, and CSS to add features and resolve frontend issues reported by users",
      "Designing and overseeing the development of the new Cluster-as-a-Service (CLaaS) website, directing user journey flows, interface layout, backend database schema, and visual style to enhance functionality and user experience"
    ],
    tech: ["Retool", "JavaScript", "CSS"],
    logo: "nvidia_logo.jpg"
  },
  {
    company: "Salesforce",
    role: "Software Engineering Intern",
    date: "May 2024 - Aug 2024",
    bullets: [
      "Developed a web app to improve monitoring & reporting of Chaos experiments by 30% via running customizable SQL queries on Amazon RDS for PostgreSQL, using Go, JS, HTML & CSS, adhering to RESTful API principles",
      "Implemented numeric/date filtering, CSV export, IAM role-based authentication & configurable parameters in YAML",
      "Containerized the app with Docker and deployed it on Kubernetes"
    ],
    tech: ["Go", "JavaScript", "HTML", "CSS", "Amazon RDS", "PostgreSQL", "Docker", "Kubernetes"],
    logo: "Salesforce-logo.jpg"
  },
  {
    company: "Relativity",
    role: "AI/ML Fellow",
    date: "May 2024 - Dec 2024",
    bullets: [
      "Evaluated bias in generative AI models impacting justice system data (text, photos, audio) using zero-shot/few-shot prompting with Gemini API for sentiment analysis and fairness metrics across nationality, disability, and age",
      "Developed templated datasets and applied classification metrics (precision, recall, F1) to identify systemic biases"
    ],
    tech: ["Gemini API", "AI/ML", "Classification Metrics"],
    logo: "relativity_logo.jpg"
  },
  {
    company: "Susquehanna International Group, LLP",
    role: "Software Engineering Intern",
    date: "June 2023 - Aug 2023",
    bullets: [
      "Created a performant, memory-efficient browser for large Hierarchical Data Format (HDF5) and Study Dataset (SDS) files using PyQt, h5py, and riptable to equip quantitative researchers to analyze and browse market data 83% faster",
      "Developed a crypto trading algorithm for Bitcoin & Ethereum, utilizing technical analysis strategies (EMA, RSI)"
    ],
    tech: ["PyQt", "h5py", "riptable", "EMA", "RSI"],
    logo: "SIG-Logo.png"
  },
  {
    company: "Zendesk",
    role: "Associate Software Developer",
    date: "Feb 2023 - Dec 2023",
    bullets: [
      "Renovated SLA ticketing system frontend with React.js & discussed design principles with Zendesk's UI/UX team",
      "Designed a robust backend infrastructure, leveraging Ruby on Rails-based API endpoints and prototyped models to detect & prevent 2000+/min traffic SLA violations, using SQL database schemas for storing notification & action data"
    ],
    tech: ["React.js", "Ruby on Rails", "SQL"],
    logo: "Zendesk-Logo.png"
  },
  {
    company: "UnitedHealth Group",
    role: "Software Engineering Intern",
    date: "June 2022 - Aug 2022",
    bullets: [
      "Designed a centralized model registry (RESTful API) for logging data of all deployed AI/ML models, enhancing discoverability across teams, reducing rework by 20%, and cutting model deployment times by 15%",
      "Built a search by model name, owner, status & tags using Java, SpringBoot, Hasura, GraphQL, Angular & Storybook"
    ],
    tech: ["Java", "SpringBoot", "Hasura", "GraphQL", "Angular", "Storybook"],
    logo: "UHC-Logo.png"
  }
]; 